import React from 'react';
import { useMutation } from '@apollo/client';

import { Section, SubSection } from '.';
import { SET_CLIENT_STATE } from '../../../graphqls';

export default function MeasurePageSettings() {
  const [setState] = useMutation(SET_CLIENT_STATE);
  const onMeasureTextClick = () => setState({ variables: { modalTypeShown: 'measureDetail' } });
  const onMeasureCommentClick = () => setState({ variables: { modalTypeShown: 'comment' } });
  const onAdditionalTextClick = () => setState({ variables: { modalTypeShown: 'additionalText' } });
  const onAdditionalBottomTextClick = () => setState({ variables: { modalTypeShown: 'additionalBottomText' } });
  const onAdditionalMiddleTextClick = () => setState({ variables: { modalTypeShown: 'additionalMiddleText' } });
  const onAdditionalUpperMiddleTextClick = () => setState({ variables: { modalTypeShown: 'additionalUpperMiddleText' } });

  return (
    <>
      <Section config={{ label: 'Measure' }}>
        <SubSection label="measureText" customClass="measure-update-section" onClick={onMeasureTextClick} />
        <SubSection label="measureComment" customClass="measure-update-section" onClick={onMeasureCommentClick} />
      </Section>
      <Section config={{ label: 'Additional Text' }}>
        <SubSection label="additionalText" customClass="plan-node-update-section" onClick={onAdditionalTextClick} />
      </Section>
      <Section config={{ label: 'Additional Text' }}>
        <SubSection label="additionalBottomText" customClass="plan-node-update-section" onClick={onAdditionalBottomTextClick} />
      </Section>
    </>
  );
}
